<template>
  <v-card class="mt-5" height='100%'>
    <v-container fluid class="pa-5">
      <v-row>
        <v-col cols="12">
          <p>Historical Days to Trade</p>
          <v-skeleton-loader v-if="dataLoad" type="card" :height="250"></v-skeleton-loader>       
          <historical-days-to-trade-bar-chart v-if="!dataLoad" :chartData="chartData" :height="250" > </historical-days-to-trade-bar-chart>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import HistoricalDaysToTradeBarChart from "@/components/HistoricalDaysToTradeBarChart";
  export default {
    name: 'StockAnalyzeComponentChartPressure',
    props: ['stock'],
    components: {HistoricalDaysToTradeBarChart},
    data() {
      return {
        chartData: {},
        dataLoad: true,        
      }
    },    
    mounted () {
      this.getDataFromApi()
    },    
    methods: {      
      async getDataFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-stock-historical-demand/' + self.stock,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.chartData = response.data 
          self.dataLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.dataLoad = false
          //self.errorbar = true
        })
      }
    },
  }
</script>